// 由 EB view/admin/src/router/modules/order.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const orderRouter: RouteRecordRaw =
  {
    path: `${roterPre}/order`,
    name: 'order',
    meta: {
      icon: 'dashboard',
      title: '订单'
    },
    alwaysShow: true,
    component: Layout,
    redirect: `${roterPre}/order`,
    children: [
      {
        path: 'list',
        name: 'OrderList',
        meta: {
          title: '订单管理'
        },
        component: () => import('@/views/order/list/index.vue')
      },
      {
        path: 'refund',
        name: 'OrderRefund',
        meta: {
          title: '退款单'
        },
        component: () => import('@/views/order/refund/index.vue')
      },
      {
        path: 'cancellation',
        name: 'OrderCancellation',
        meta: {
          title: '核销订单'
        },
        component: () => import('@/views/order/orderCancellate/index.vue')
      },
      {
        path: 'verifyRecord',
        name: 'VerifyRecord',
        meta: {
          title: '次卡核销记录'
        },
        component: () => import('@/views/order/verifyRecord/index.vue')
      }
    ]
  }

export default orderRouter;
